import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getFriendCardBetsStyles = (theme: Theme) =>
  StyleSheet.create({
    betCard: {
      backgroundColor: theme.gray[100],
      borderRadius: 12,
      padding: 12,
      borderWidth: 1,
      borderColor: theme.gray[200],
      gap: 10,
      marginBottom: 12,
    },
    betCardHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    betLeague: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.gray[800],
    },
    badgeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    timeBadge: {
      backgroundColor: theme.primary,
      borderRadius: 12,
      paddingHorizontal: 10,
      paddingVertical: 4,
    },
    countdownBadge: {
      backgroundColor: '#F97316',
      borderRadius: 12,
      paddingHorizontal: 10,
      paddingVertical: 4,
    },
    badgeText: {
      color: theme.white,
      fontSize: 12,
      fontWeight: '600',
    },
    teamName: {
      flex: 1,
      fontSize: 15,
      fontWeight: '600',
      color: theme.black,
    },
    teamNameRight: {
      textAlign: 'right',
    },
    vsLabel: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.primary,
      paddingHorizontal: 8,
    },
    oddsRow: {
      flexDirection: 'row',
      borderRadius: 10,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: theme.gray[200],
      backgroundColor: theme.gray[100],
    },
    oddsPill: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.card,
      paddingVertical: 10,
    },
    oddsPillLeft: {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
    oddsPillRight: {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    },
    oddsPillSelected: {
      backgroundColor: '#E53E3E',
    },
    oddsValue: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.gray[800],
    },
    oddsValueSelected: {
      color: theme.white,
    },
    emptyMatchesText: {
      fontSize: 13,
      color: theme.gray[600],
    },
    updateButton: {
      marginTop: 4,
      backgroundColor: '#6B46C1',
      paddingVertical: 12,
      borderRadius: 12,
      alignItems: 'center',
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.12,
      shadowRadius: 4,
      elevation: 3,
    },
    updateButtonDisabled: {
      backgroundColor: theme.gray[300],
      shadowOpacity: 0,
      elevation: 0,
    },
    updateButtonText: {
      fontSize: 15,
      fontWeight: '700',
      color: theme.white,
    },
    updateButtonTextDisabled: {
      color: theme.white,
      opacity: 0.7,
    },
  });
